import { InjectionToken } from '@angular/core';

import { PartnerConfig } from './model';

export const PARTNER_CONFIG = new InjectionToken<PartnerConfig>(
  'PartnerConfigToken',
);
